import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AirplaneTakeOffFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M16.9961 4.94927C18.0248 4.45896 19.322 4.29651 20.3408 4.5186L21.6231 4.78716L21.6416 4.79107L22.3216 4.94927C23.9146 5.36993 24.1644 6.89115 22.8448 7.80712L22.2461 8.20513L17.751 11.1143L14.4707 19.0186C14.4092 19.1665 14.3013 19.2915 14.1641 19.3741L11.4375 21.0157C11.1944 21.1617 10.889 21.1577 10.6494 21.0059C10.4098 20.854 10.2764 20.5792 10.3047 20.2969L10.8486 14.8917L6.6963 16.7364C6.47466 16.8348 6.21855 16.8197 6.00978 16.6963L1.25196 13.8838C1.02265 13.7481 0.882323 13.5009 0.883801 13.2344C0.885445 12.9676 1.02947 12.7209 1.26075 12.5879L3.64161 11.2198L3.71193 11.1836C3.87864 11.1099 4.06778 11.0994 4.24318 11.1553L5.89747 11.6836L9.14161 9.71001L9.13868 9.70806L16.1777 5.42778L16.1768 5.42583L16.7598 5.07134L16.7764 5.06157L16.794 5.05181L16.9961 4.94927Z"
				fill="currentColor"
			/>
			<path
				d="M7.45607 4.97271L12.6192 5.83599L7.6963 8.82915L5.16114 7.28521C4.93045 7.14476 4.79238 6.89105 4.80079 6.62114C4.80953 6.35117 4.96301 6.10601 5.20216 5.98052L6.98439 5.0479L7.09571 5.00005C7.21098 4.96182 7.33509 4.9525 7.45607 4.97271Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AirplaneTakeOffFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AirplaneTakeOffFilledIcon;
